export default __webpack_public_path__ + "static/media/bgBlue400x300.328968a1.jpg";